import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { expertTipTopicScheduleApi } from '../services/adminApi';
import { queryKeys } from '../utils/queryKeys';

export function useExpertTipTopicSchedules(params: { year: number; month: number }) {
  return useQuery({
    queryKey: queryKeys.expertTipTopicSchedules.list(params),
    queryFn: () => expertTipTopicScheduleApi.listSchedules(params),
  });
}

export function useCreateExpertTipTopicSchedule() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dto: { topicId: number; weekStart: string }) =>
      expertTipTopicScheduleApi.createSchedule(dto),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.expertTipTopicSchedules.lists() });
    },
  });
}

export function useDeleteExpertTipTopicSchedule() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => expertTipTopicScheduleApi.deleteSchedule(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.expertTipTopicSchedules.lists() });
    },
  });
}
